
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/86d54ddcda63029da005b85ca6e54f68/b5a6c0d9bc70d8400f36872c2465ceb8.png" 
                alt="Hugh Muir Investment Corp Logo" 
                className="h-8 w-auto"
              />
              <h3 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                HUGH MUIR INVESTMENT CORP
              </h3>
            </div>
            <p className="text-gray-300 mb-4">
              Professional investment management and financial advisory services helping you achieve sustainable growth and wealth preservation.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Investment Management</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Wealth Planning</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Portfolio Advisory</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Financial Planning</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Retirement Planning</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Our Team</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Careers</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">News &amp; Insights</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-400 mt-1"></i>
                <span>1 Tiffany Point Suite G 10<br />Bloomington, IL 60618</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-teal-400"></i>
                <span>(773) 850-0803</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-teal-400"></i>
                <span>info@hughmuir.com</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 HUGH MUIR INVESTMENT CORP. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="/terms" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
        
      </div>
    </footer>
  );
};
